import { BaseAPI, Common } from '../../common';

import Encounter from './encounter';
import Order from './order';
import Patient from './patient';

export default class API extends BaseAPI {
  Encounter: Encounter;
  Order: Order;
  Patient: Patient;

  constructor(common: Common) {
    super(common);
    this.Encounter = new Encounter(common);
    this.Order = new Order(common);
    this.Patient = new Patient(common);
  }
}
